import { supabase } from "@/services/supabase/createClient";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { Container, Flex, HStack, Link, Stack, Text } from "@chakra-ui/react";
import { PromptStudioLogo } from "@pufflig/prompt-studio-ui";

export const LoginPage = () => {
  return (
    <Container maxW="md" py={{ base: "12", md: "24" }}>
      <Stack spacing="4">
        <Stack spacing="6">
          <Flex width="100%" justifyContent="center">
            <Flex width="5rem">
              <PromptStudioLogo />
            </Flex>
          </Flex>
          <Stack spacing="3" textAlign="center">
            <Text textStyle="heading/1">Log in to Prompt Studio</Text>
            <Text textStyle="label/L/regular">Start prompting with ease</Text>
          </Stack>
        </Stack>
        <Auth
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: { inputText: "var(--chakra-colors-foreground-primary)" },
              },
              dark: {
                colors: { inputText: "var(--chakra-colors-foreground-primary)" },
              },
            },
          }}
          supabaseClient={supabase}
          providers={["google", "azure", "github"]}
          onlyThirdPartyProviders={import.meta.env.VITE_ENVIRONMENT !== "staging"}
        />
        <HStack spacing="1" justify="center">
          <Text textStyle="label/S/regular">
            Having issues?{" "}
            <Link textDecoration={"underline"} href="mailto:support@prompt.studio">
              Contact us
            </Link>
          </Text>
        </HStack>
      </Stack>
    </Container>
  );
};
